<template>
    <div class="image-selector">
        <div 
            class="drop-zone"
            :class="{ 
                'drag-over': isDragOver, 
                'disabled': disabled 
            }"
            @click="triggerFileInput"
            @dragover.prevent="handleDragOver"
            @dragleave.prevent="handleDragLeave"
            @drop.prevent="handleDrop"
        >
            <!-- Área de seleção inicial -->
            <div class="selection-area">
                <div class="selection-content">
                    <i class="fa fa-cloud-upload icon-upload" style="font-size: 30px;"></i>
                    <h6>Selecione ou arraste uma imagem aqui</h6>
                </div>
            </div>

            <!-- Input file oculto -->
            <input
                ref="fileInput"
                type="file"
                :accept="acceptString"
                :disabled="disabled"
                @change="handleFileSelect"
                style="display: none;"
            />
        </div>

        <!-- Modal de Cropper -->
        <modal name="modalCropImagecmp" height="auto">
            <div class="container-cropper card">
                <div class="card-header titulo-cropper">
                    <h4>Recorte da imagem</h4>
                    <p><i class="fa fa-object-group" aria-hidden="true"></i> {{ tituloCropper }}</p>
                </div>
                <div class="card-body body-cropper">
                    <cropper
                        ref="cropper"
                        :src="imgselecionada"
                        :stencil-props="{
                            aspectRatio: aspectRatioCropper,
                            scalable: scalableCropper,
                        }"
                    />
                </div>
                <div class="card-footer">
                    <small>Proporção da imagem:</small>
                    <div class="aspectRatios">
                        <button v-if="cropperRatios.includes('livre')" @click="mtdalteraproporcaocropper('livre')" class="btn-aspectratio">Livre</button>
                        <button v-if="cropperRatios.includes('1:1')" @click="mtdalteraproporcaocropper('1:1')" class="btn-aspectratio"><div class="p1-1"></div><small>1:1</small></button>
                        <button v-if="cropperRatios.includes('27:9')" @click="mtdalteraproporcaocropper('27:9')" class="btn-aspectratio"><div class="p27-9"></div><small>27:9</small></button>
                        <button v-if="cropperRatios.includes('25:9')" @click="mtdalteraproporcaocropper('25:9')" class="btn-aspectratio"><div class="p25-9"></div><small>25:9</small></button>
                        <button v-if="cropperRatios.includes('23:9')" @click="mtdalteraproporcaocropper('23:9')" class="btn-aspectratio"><div class="p23-9"></div><small>23:9</small></button>
                        <button v-if="cropperRatios.includes('16:9')" @click="mtdalteraproporcaocropper('16:9')" class="btn-aspectratio"><div class="p16-9"></div><small>16:9</small></button>
                    </div>
                    <div class="btns-cropper">
                        <button @click.prevent="cancelarCropper()" class="btn btn-secondary">Cancelar</button>
                        <button @click.prevent="confirmarImagemCortada()" class="btn btn-primary">Salvar Alterações</button>
                    </div>    
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import imageCompression from 'browser-image-compression';

    export default {
        name: 'cmpselecionarimagem',
        props: {
            // Formatos de imagem aceitos
            acceptedFormats: {
                type: Array,
                default: () => ['jpg', 'jpeg', 'png', 'gif', 'webp']
            },
            // Valor inicial (URL da imagem)
            value: {
                type: String,
                default: null
            },
            // Desabilitar o componente
            disabled: {
                type: Boolean,
                default: false
            },
            // Proporções disponíveis no cropper
            cropperRatios: {
                type: Array,
                default: () => ['1:1', '16:9', '23:9', '25:9', '27:9', 'livre']
            },
            // Opções de compressão
            compressionOptions: {
                type: Object,
                default: () => ({
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1920,
                    useWebWorker: true,
                    initialQuality: 0.7
                })
            }
        },
        data() {
            return {
                isDragOver: false,
                // Dados para o cropper
                imgselecionada: null,
                extimgselecionada: null,
                tituloCropper: 'Livre',
                aspectRatioCropper: null,
                scalableCropper: false
            }
        },
        computed: {
            acceptString() {
                return this.acceptedFormats.map(format => `image/${format}`).join(',');
            }
        },
        methods: {
            triggerFileInput() {
                if (!this.disabled) {
                    this.$refs.fileInput.click();
                }
            },

            handleDragOver(event) {
                if (!this.disabled) {
                    this.isDragOver = true;
                }
            },

            handleDragLeave(event) {
                this.isDragOver = false;
            },

            handleDrop(event) {
                if (this.disabled) return;
                
                this.isDragOver = false;
                const files = event.dataTransfer.files;
                
                if (files.length > 0) {
                    this.processFile(files[0]);
                }
            },

            handleFileSelect(event) {
                const file = event.target.files[0];
                if (file) {
                    this.processFile(file);
                }
                // Limpa o input para permitir selecionar o mesmo arquivo novamente
                event.target.value = '';
            },
            async processFile(file) {
                // Arquivo válido - abrir modal de cropper
                this.extimgselecionada = this.getFileExtension(file.name);
                this.imgselecionada = URL.createObjectURL(file);
                this.mtdalteraproporcaocropper(this.cropperRatios[0]);
                this.$modal.show('modalCropImagecmp');
            },
            getFileExtension(filename) {
                return filename.split('.').pop().toLowerCase();
            },
            // Métodos do cropper
            mtdalteraproporcaocropper(ratio) {
                this.aspectRatioCropper = null;
                switch (ratio) {
                    case '1:1':
                        this.tituloCropper = '1:1';
                        this.aspectRatioCropper = 1;
                        this.scalableCropper = true;
                        break;
                    case '16:9':
                        this.tituloCropper = '16:9';
                        this.aspectRatioCropper = 16 / 9;
                        this.scalableCropper = true;
                        break;
                    case '23:9':
                        this.tituloCropper = '23:9';
                        this.aspectRatioCropper = 23 / 9;
                        this.scalableCropper = true;
                        break;
                    case '25:9':
                        this.tituloCropper = '25:9';
                        this.aspectRatioCropper = 25 / 9;
                        this.scalableCropper = true;
                        break;
                    case '27:9':
                        this.tituloCropper = '27:9';
                        this.aspectRatioCropper = 27 / 9;
                        this.scalableCropper = true;
                        break;
                    default:
                        this.tituloCropper = 'Livre';
                        this.aspectRatioCropper = null;
                        this.scalableCropper = false;
                        break;
                }
            },

            cancelarCropper() {
                this.imgselecionada = null;
                this.extimgselecionada = null;
                this.aspectRatioCropper = null;
                this.scalableCropper = false;
                this.$modal.hide('modalCropImagecmp');
            },

            confirmarImagemCortada() {
                let vself = this;
                this.processarImagemCortada();
            },

            async processarImagemCortada() {
                // PEGA A IMAGEM RECORTADA E CONVERTE PARA BLOB -> ARQUIVO
                const { canvas } = this.$refs.cropper.getResult();

                const createBlob = () => {
                    return new Promise((resolve) => {
                        canvas.toBlob((blob) => {
                            resolve(blob);
                        }, `image/${this.extimgselecionada}`);
                    });
                };

                const blob = await createBlob();

                // Monta o arquivo original
                const originalFile = new File(
                    [blob],
                    `imagem.${this.extimgselecionada}`,
                    { type: `image/${this.extimgselecionada}` }
                );

                let processedFile = originalFile;

                // OPÇÕES DE COMPRESSÃO
                const options = {
                    maxSizeMB: this.compressionOptions.maxSizeMB,
                    maxWidthOrHeight: this.compressionOptions.maxWidthOrHeight,
                    useWebWorker: this.compressionOptions.useWebWorker,
                    initialQuality: this.compressionOptions.initialQuality
                };

                // COMPRIMINDO O ARQUIVO
                try {
                    processedFile = await imageCompression(originalFile, options);
                } catch (error) {
                    console.warn('Erro na compressão da imagem:', error);
                    // Continua com o arquivo original se a compressão falhar
                }

                // Emitir eventos
                this.$emit('input', URL.createObjectURL(processedFile));
                this.$emit('file-selected', processedFile);
                this.$emit('change', {
                    file: processedFile,
                    url: URL.createObjectURL(processedFile),
                    originalFile: originalFile
                });

                // Fechar modal
                this.cancelarCropper();
            }
        },

        beforeDestroy() {
            // Limpar URLs de objeto para evitar vazamentos de memória
            if (this.imgselecionada && this.imgselecionada.startsWith('blob:')) {
                URL.revokeObjectURL(this.imgselecionada);
            }
        }
    }
</script>

<style scoped>
    .image-selector {
        width: 100%;
    }

    .drop-zone {
        position: relative;
        border: 2px dashed #ced4da;
        border-radius: 8px;
        background-color: #f8f9fa;
        cursor: pointer;
        transition: all 0.3s ease;
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .drop-zone:hover:not(.disabled) {
        border-color: #007bff;
        background-color: #e7f3ff;
    }

    .drop-zone.drag-over {
        border-color: #007bff;
        background-color: #e7f3ff;
        transform: scale(1.02);
    }

    .drop-zone.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .selection-area {
        text-align: center;
        padding: 40px 20px;
        width: 100%;
    }

    .selection-content h4 {
        margin: 15px 0 10px 0;
        color: #495057;
        font-weight: 500;
    }

    .icon-upload {
        font-size: 48px;
        color: #6c757d;
        margin-bottom: 10px;
    }

    /* Responsividade */
    @media (max-width: 576px) {
        .selection-area {
            padding: 30px 15px;
        }
        
        .icon-upload {
            font-size: 36px;
        }
    }

    /* Estilos do Cropper Modal - Baseados no ecommerceconfig.vue */
    .container-cropper{
        & > .titulo-cropper{
            display: flex;
            justify-content: space-between;
        }
        & > .body-cropper{
            height: 50vh;
        }
    }
    .btns-cropper{
        display: flex;
        justify-content: space-between;
        margin-block: 20px;
    }

    .aspectRatios {
        display: flex;
        margin-bottom: 10px;
    }

    .btn-aspectratio{
        height: 43px;
        width: 60px;
        margin: 5px;
        border: 1px solid #0d214e7b;
        border-radius: 5px;
        background-color: #fff;
        color: #0d214ef4;
        font-weight: 600;
        transition: background-color 0.4s;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 0px 5px 0px #0000002f;
        &:hover{
            background-color: rgba(0, 33, 87, 0.676);
            color: #Fff;
            cursor: pointer;
        }
        & > div {
            border: 3px solid #0d214e7b;
        }
        &:hover > div {
            border: 3px solid #ffffffc4;
        }
        & > small {
            height: 10px;
            font-size: 10px;
        }

        & > .p1-1 {
            height: 20px;
            width: 20px;
        }
        & > .p27-9 {
            height: 15px;
            width: 30px;
        }
        & > .p25-9 {
            height: 18px;
            width: 30px;
        }
        & > .p23-9 {
            height: 20px;
            width: 30px;
        }
        & > .p16-9 {
            height: 22px;
            width: 30px;
        }
    }
</style>